import { AxiosError } from 'axios'
import { useMutation, UseMutationResult, useQueryClient } from 'react-query'

import http from '../helpers/http'
import { toBase64 } from '../helpers/common'
import { getApiURLAndClientID } from '../helpers/utils'
import { ICredentials, ILoginResponse } from '../types/'

export const userProfileKey = 'user-profile'

export function useUserLogin(): UseMutationResult<ILoginResponse, AxiosError, ICredentials> {
  const queryClient = useQueryClient()
  const mutationFn = ({ userName, password }: ICredentials): Promise<ILoginResponse> => {
    const { clientId } = getApiURLAndClientID()
    return http
      .post(
        '/auth',
        { userName, password },
        { headers: { authorization: 'basic ' + toBase64(`${clientId}:`), skipAuth: 'true' } }
      )
      .then((res) => res.data)
  }
  return useMutation(mutationFn, {
    onSuccess(data: ILoginResponse) {
      if (data?.user) {
        queryClient.setQueryData([userProfileKey], data.user)
      }
    },
  })
}
